import React, { FC } from 'react';
import App from '../../App';

const Root: FC = () => {
  return <App />;
};

export default Root;
